import React from 'react';
import { Dialog, DialogContent, CardMedia, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styles } from './MuiStyles';

function ImagePopup({ image, onClose }) {
  return (
    <Dialog 
      open={!!image} 
      onClose={onClose} 
      maxWidth={false}
      fullWidth
      PaperProps={{
        style: styles.imagePopup.dialog,
      }}
    >
      <DialogContent style={styles.imagePopup.dialogContent}>
        <IconButton
          onClick={onClose}
          sx={styles.imagePopup.closeButton}
        >
          <CloseIcon sx={styles.imagePopup.closeIcon} />
        </IconButton>
        <CardMedia
          component="img"
          sx={styles.imagePopup.cardMedia}
          image={image}
          alt="Selected image"
        />
      </DialogContent>
    </Dialog>
  );
}

export default ImagePopup;